define('commons/availability-analyser',['jquery', 'commons/monitoring/availability-monitoring', 'commons/message-manager'], function($, AvailabilityMonitoring, messages) {
    function Availability(options) {
        
        this.options = $.extend(true, {
            powerRange: 171,
            minPower: -170,
            minSNR: 8,
            spectUnderSpl: 2,
            dt: 0.2,
            frameTime: 2.08,
            sensitivityDegradation: 0,
            t: 10,
            availOffset: -10 * Math.log10(330) + 10 * Math.log10(100)
        }, options);
        
        this.options.minSNR = this.options.minSNR + this.options.sensitivityDegradation;
    
        // initialize values
        this.init(this.options.minSNR, this.options.spectUnderSpl, this.options.t);

        // Availabilty graphs
        this.density = new AvailabilityMonitoring(['density'], 'density-monitoring-container', {
            'keys': ['density'],
            'labels': ['density']
        }, false, {
            ylabel: 'Density (%)',
            xlabel: 'Power (dBm)'
        });
        this.density.values.step = 1;

        this.availability = new AvailabilityMonitoring(['availability'], 'availability-monitoring-container', {
            'keys': ['availability'],
            'labels': ['cumul density']
        }, false, {
            ylabel: 'Availability (%)',
            xlabel: 'Power (dBm)'
        });
        this.availability.values.step = 1;
        
        $("#update-params").on('click', $.proxy(function() {
            var minSNR = parseFloat($("input#minSNR").val()).toFixedNumber(1);
            var spectunderspl = parseInt($("input#spectunderspl").val());
            var time = parseInt($("input#time").val());

            if (!isNaN(minSNR) && minSNR >= 0 && minSNR <= 100 && !isNaN(spectunderspl) && spectunderspl >=1 && spectunderspl <= 8 && !isNaN(time) && time >=10 && time <= 3600) {            
                this.options = $.extend(true, this.options, {minSNR : minSNR, spectUnderSpl: spectunderspl, t:time});
                this.init(minSNR, spectunderspl, time);
                messages.info('Availability parameters sucessfully updated');
            } else {
                messages.error("invalid parameter value");
            }
        }, this));
    };
    
    Availability.prototype.process = function(specti) {
        this.sliceCnt++;
        this.timeCnt += this.options.dt;
        
        var k = 0;
        // For every pixel taken each SPECTUNDERSPL pixels of the incoming spectrum, keep the bin
        // maximum power over FRAMEDUR in maxPowerAvailBin.
        for (var p = 0; p < specti.length; p += this.options.spectUnderSpl) {
            this.maxPowerAvailBin[k] = Math.max(specti[p] + this.options.availOffset, this.maxPowerAvailBin[k]);
            k++;
        }
        
        if (this.sliceCnt == this.frameDur) {
            // for each value of maxPowerAvailBin compute an index that fits in POWERRANGE and
            // increment the corresponding unit counter.
            for (var j = 0; j < k; j++) {
                var maxPowerAvail = Math.floor(Math.min(this.maxPowerAvailBin[j], this.maxPower) + this.options.minSNR);
                this.availUnitDistrib[maxPowerAvail - this.options.minPower] += 1;
                this.totalNumberUnits++;
            }
            this.sliceCnt = 0;
            for(var j = 0; j < this.availSpectLgth; j++) {
                this.maxPowerAvailBin[j] = -300;
            }
        }
        
        if (this.timeCnt >= this.options.t) {
            var density = [];
            var cumul = [];
            var sum = 0;
            for(var j = 0; j < this.options.powerRange; j++) {
                density[j] = 100 * this.availUnitDistrib[j] / this.totalNumberUnits;
                this.availUnitDistrib[j] = 0;
                // compute the cumulative density function
                sum += density[j];
                cumul[j] = sum;
            }
            this.timeCnt = 0;
            this.totalNumberUnits = 0;
            this.plot(density, cumul);
        }
        
    };
    
    Availability.prototype.plot = function(density, cumul) {
        this.density.values.lastPower = this.maxPower;
        this.density.values.data.density = density;
        this.density.loadData();
        this.availability.values.lastPower = this.maxPower;
        this.availability.values.data.availability = cumul;
        this.availability.loadData();
    };
    

    Availability.prototype.init = function(minSNR, spectUnderSpl, t) {
        this.sliceCnt = 0;
        this.timeCnt = 0;
        this.totalNumberUnits = 0;
        this.maxPowerAvailBin = [];
        this.availSpectLgth = Math.floor(1024 / this.options.spectUnderSpl);
        for(var i = 0; i < this.availSpectLgth; i++) {
            this.maxPowerAvailBin[i] = -300;
        }
        this.maxPower = this.options.minPower + this.options.powerRange - 1;
        this.frameDur = Math.floor(this.options.frameTime / this.options.dt);
        this.availUnitDistrib = []
        for(var i = 0; i < this.options.powerRange; i++) {
            this.availUnitDistrib[i] = 0;
        }
        $("input#minSNR").val(minSNR);
        $("input#spectunderspl").val(spectUnderSpl);
        $("input#time").val(t);
    };

    Availability.prototype.reload = function() {
        this.availability.redraw();
        this.density.redraw();
    };

    Number.prototype.toFixedNumber = function(digits){
      var pow = Math.pow(10, digits);
      return Math.round(this*pow) / pow;
    }

    return Availability;
});
